import jsbridge from '@xpeng/js-bridge'

interface CarInfo {
  platenum: string
  vin: string
  series?: string
  specialFlag?: number
}

export const getCurrentVehicleInfoFromApp = (): Promise<CarInfo> => {
  return new Promise((resolve, reject) => {
    jsbridge.callHandler('getCarInfo', {}).then((data) => {
      const response = typeof data === 'string' ? JSON.parse(data) : data
      if (response.code === 0) {
        response.data =
          typeof response.data === 'string'
            ? JSON.parse(response.data)
            : response.data
        console.log(`app car info --->`, response.data)
        const vehicleInfo = {
          vin: response.data.vin,
          platenum: response.data.plateNo,
        }
        resolve(vehicleInfo)
      } else {
        resolve({
          vin: '',
          platenum: '',
        })
      }
    })
  })
}

interface UserInfo {
  username: string
  mobile: string
}
export const getUserInfoFromApp = (): Promise<UserInfo> => {
  return jsbridge.callHandler('getLoginState').then((data) => {
    const response = typeof data === 'string' ? JSON.parse(data) : data
    if (response.loginState) {
      return {
        username: response.data.username,
        mobile: response.data.mobile,
      }
    } else {
      return {
        username: '',
        mobile: '',
      }
    }
  })
}
